<script>
    import {Modal, ModalBody, ModalHeader} from 'sveltestrap';
    
    export let title = '';
    export let open = false;
    export let size = 'lg';
    
    const toggle = () => (open = !open);
</script>

<Modal on:closing isOpen={open} {size} {toggle}>
    <ModalHeader {toggle}>{title}</ModalHeader>
    <ModalBody>
        <slot></slot>
    </ModalBody>
</Modal>
